
import React from 'react';
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import TextEditorOrderedListWrapper from './styles/TextEditorOrderedListWrapper';

export default function OrderedItemComponent(props) {
  return (
    <NodeViewWrapper className="bullet-item">
      <TextEditorOrderedListWrapper color={props.node.attrs.color} fontSize={props.node.attrs.fontSize && !props.node.attrs.fontSize.toString().endsWith('.') && props.node.attrs.fontSizeUnit  ? `${props.node.attrs.fontSize}${props.node.attrs.fontSizeUnit}` : '1em'}>
        <NodeViewContent contentEditable={true}/>
      </TextEditorOrderedListWrapper>
    </NodeViewWrapper>
  );
}



